import React from 'react';
import { IntentType, INTENT_LABELS } from '../../../types/annotation';

interface IntentSelectorProps {
  value: IntentType | null;
  onChange: (v: IntentType) => void;
  disabled?: boolean;
}

const INTENT_ORDER: IntentType[] = [
  'complaint',
  'praise',
  'opinion',
  'demand',
  'narrative',
  'comparison',
  'explanation',
  'request',
  'question',
  'agreement',
  'disagreement',
];

const IntentSelector: React.FC<IntentSelectorProps> = ({ value, onChange, disabled = false }) => {
  return (
    <select
      value={value ?? ''}
      onChange={(e) => {
        if (e.target.value) onChange(e.target.value as IntentType);
      }}
      disabled={disabled}
      className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent bg-white disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <option value="">— Select intent —</option>
      {INTENT_ORDER.map((intent) => (
        <option key={intent} value={intent}>
          {INTENT_LABELS[intent]}
        </option>
      ))}
    </select>
  );
};

export default IntentSelector;
